import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TourService, TourStep } from './tour.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageDropdownComponent } from '../shared/components/language-dropdown/language-dropdown.component';
import { TourRevealDirective } from './tour-reveal.directive';

@Component({
  selector: 'app-tour-page', standalone: true, imports: [CommonModule, TranslateModule, LanguageDropdownComponent, TourRevealDirective],
  templateUrl: './tour-page.component.html', styleUrls: ['./tour-page.component.scss']
})
export class TourPageComponent implements OnInit, OnDestroy {
  readonly roadmap = ['REWARDS', 'FAVORITES', 'PLAN', 'CIRCLES', 'REVIEWS', 'MENU_SEARCH', 'KEEP_DISCOVERING'];
  readonly featureDelay = 120;
  get actionsDelay(): number { return this.tour.step === 'future' ? 1500 + (this.roadmap.length - 1) * this.featureDelay + 550 : 2620; }
  private subscription = new Subscription();
  constructor(public tour: TourService, private route: ActivatedRoute, private title: Title, public translate: TranslateService) {}
  ngOnInit(): void {
    this.subscription.add(this.route.data.subscribe(data => {
      this.tour.enterReading((data['tourStep'] || 'intro') as TourStep);
    }));
    this.subscription.add(this.translate.stream('TOUR.TITLE').subscribe(title => this.title.setTitle(title)));
  }
  ngOnDestroy(): void { this.subscription.unsubscribe(); }
}
